<div class="error">{{ error }}</div>

<loader-bar *ngIf="loggingIn"></loader-bar>
<div #loginInterfaceVc></div>
<div class="sign-up" [ngClass]="{ baoying: isBaoying() }" *ngIf="showSignUp()">
  <span>{{ 'noAccount' | i18n : 'sso-login' }}</span
  >&nbsp;
  <a href="#" (click)="goToEnroll($event)" data-automation="enrollLink">{{ 'signUp' | i18n : 'sso-login' }}</a>
</div>
